import React, {FC} from "react";
import {Box} from "@mui/material";

interface Props {
    latitude: string;
    longitude: string;
    height?: number;
    width?: string;
}

export const GarageDetailsMap: FC<Props> = ({latitude, longitude, height = 300,width="100%"}) => (
    <Box sx={{height: height, width: "100%"}}>
        <iframe
            width={width}
            height={height}
            style={{
                border: 0,
                borderRadius: 8,
                boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
            }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            src={`https://www.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`}
            title="Garage Location"
        />
    </Box>
);
